import { AUTHORIZATION_HEADER } from '../../../../../../src/authorization';
import { send } from '../../../../../../src/network';
import {
  type CustomerPaymentPayload,
  type CustomerPaymentResponse,
} from '../../../../../../src/types/CustomerPayment';

export type SavePayment400Problem = { detail: string[] };
export type SavePayment403Problem = { detail: string };

export type SavePaymentResponse =
  | { status: 200; data: CustomerPaymentResponse }
  | { status: 400; data: SavePayment400Problem }
  | { status: 403; data: SavePayment403Problem };

export async function postApiV2CustomersCustomerIdPayment(
  params: CustomerPaymentPayload
) {
  const res = (await send<unknown>({
    path: `/api/v2/customers/self/payment/`,
    method: 'POST',
    headers: new Headers({
      AUTHORIZATION: AUTHORIZATION_HEADER,
    }),
    body: params,
  })) as SavePaymentResponse;

  return res;
}
